export default {"src":"/_next/static/media/monitor.496ea289.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};